export const OS_PRIORIDADE_META = Object.freeze({
  1: {
    variant: "low",
    icon: "InfoIcon",
    label: "BAIXA",
    title: "Prioridade Baixa",
  },
  2: {
    variant: "med",
    icon: "AlertCircleIcon",
    label: "MÉDIA",
    title: "Prioridade Média",
  },
  3: {
    variant: "high",
    icon: "AlertTriangleIcon",
    label: "ALTA",
    title: "Prioridade Alta",
  },
});

export function getOsPrioridadeMeta(id) {
  if (id == null || id === "") {
    return null;
  }
  return OS_PRIORIDADE_META[id] || null;
}
